const L = {
  name: "RevenueAccelerate",
  dimensions: { width: 40, height: 41 },
  content: `
    <g fill="currentColor" stroke="none">
      <path d="M1.01048 18.9778C0.454718 18.9778 0 19.4373 0 19.9988C0 20.5604 0.454718 21.0199 1.01048 21.0199C1.56625 21.0199 2.02097 20.5604 2.02097 19.9988C2.02097 19.427 1.56625 18.9778 1.01048 18.9778Z"/>
      <path d="M20.2097 37.9491L14.2579 31.9351L26.0705 19.9989L14.2579 8.05252L20.2097 2.03848L37.9841 19.9989L20.2097 37.9491ZM8.15461 19.9989L5.29494 17.1093L7.64937 14.7302L12.8635 19.9989L7.64937 25.2676L5.29494 22.8885L8.15461 19.9989ZM12.823 9.50242L23.2108 19.9989L12.823 30.4852L9.08426 26.7073L15.7332 19.9887L9.08426 13.2701L12.823 9.50242ZM39.4089 18.549L21.6345 0.598785C20.8463 -0.197642 19.563 -0.197642 18.7748 0.598785L2.43527 17.1093L5.29494 19.9989L2.43527 22.8885L18.7748 39.399C19.1689 39.7973 19.6842 40.0015 20.1996 40.0015C20.7149 40.0015 21.2303 39.7973 21.6244 39.399L39.4089 21.4386C40.197 20.6422 40.197 19.3454 39.4089 18.549Z"/>
    </g>
  `
};
export {
  L as RevenueAccelerate
};
